<template>
  <div class="d-flex flex-column ga-4">
    <v-card border rounded="lg" class="pa-4">
      <div class="d-flex align-center justify-space-between ga-4 flex-wrap">
        <div class="d-flex align-center ga-4">
          <v-avatar color="primary" variant="tonal" size="48">
            <span class="text-h6">{{ debtorInitial }}</span>
          </v-avatar>
          <div>
            <div class="text-disabled font-size-13">Боржник</div>
            <div class="text-h6 font-weight-bold">{{ data.debtorName }}</div>
          </div>
        </div>

        <div class="d-flex flex-column align-center">
          <div class="text-disabled font-size-13 mb-1">Код ЄДРПОУ</div>
          <v-chip color="grey-darken-1" size="small">
            <b>{{ data.debtorCode }}</b>
          </v-chip>
        </div>
      </div>
    </v-card>

    <div class="d-flex ga-4 flex-wrap">
      <v-card border rounded="lg" class="pa-4 flex-grow-1">
        <div class="d-flex align-center ga-3">
          <v-avatar color="primary" variant="tonal" size="40">
            <v-icon icon="mdi-cube-outline"></v-icon>
          </v-avatar>
          <div>
            <div class="font-weight-bold">Всього: {{ data.packagesCount }}</div>
            <div class="text-disabled font-size-13">пакетів подано</div>
          </div>
        </div>
      </v-card>

      <v-card border rounded="lg" class="pa-4 flex-grow-1">
        <div class="d-flex align-center ga-3">
          <v-avatar color="primary" variant="tonal" size="40">
            <v-icon icon="mdi-calendar-range"></v-icon>
          </v-avatar>
          <div>
            <div class="font-weight-bold">
              {{ data.periodFrom }} — {{ data.periodTo }}
            </div>
            <div class="text-disabled font-size-13">звітний період</div>
          </div>
        </div>
      </v-card>
    </div>

    <chronology-section
      v-for="name in sectionOrder"
      :key="name"
      :name="name"
      :datasets="data.chronology[name] || []"></chronology-section>

    <div class="text-disabled font-size-13 text-center">
      Статус кожного запису визначено за подією F150 останньої подачі. Дані
      наведено станом на останній прийнятий пакет.
    </div>
  </div>
</template>

<script lang="ts">
import { computed, PropType } from 'vue'
import type { DebtorChronology } from '@/utils/types'
import ChronologySection from './ChronologySection.vue'
import { sectionOrder } from './helpers'

export default {
  name: 'DebtorChronologyReport',
  components: { ChronologySection },
  props: {
    debtorChronology: {
      type: Object as PropType<DebtorChronology>,
      required: true,
    },
  },
  setup(props) {
    const data = computed(() => props.debtorChronology.data)

    const debtorInitial = computed<string>(() => {
      return (data.value.debtorName || '').trim().charAt(0).toUpperCase() || '—'
    })

    return { data, debtorInitial, sectionOrder }
  },
}
</script>

<style scoped lang="scss"></style>
